// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sb_QqNKeadm2oq {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex-basis: 272px;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: start;
  justify-content: space-between;
  width: 272px;
  max-height: 100%;
  padding-bottom: var(--ds-space-050, 4px);
  border-radius: 12px;
  background-color: var(--accent-background, var(--tr-background-list));
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--accent-text, var(--ds-text-subtle, #44546f));
  vertical-align: top;
  white-space: normal;
  scroll-margin: 8px;
}
@media only screen and (max-width: 750px) {
  .Sb_QqNKeadm2oq {
    scroll-snap-align: center;
  }
}
@media print {
  .Sb_QqNKeadm2oq {
    margin-bottom: 16px;
  }
}
.Sb_QqNKeadm2oq.WvZExniDZRwinU {
  flex-basis: auto;
  width: auto;
  max-width: fit-content;
  padding-bottom: 0;
}
.Sb_QqNKeadm2oq.dq7WRhjf8qPZsx {
  outline: 2px solid var(--ds-border-focused, #388bff);
}
.mac .Sb_QqNKeadm2oq.dq7WRhjf8qPZsx {
  outline-color: -webkit-focus-ring-color;
}
.mac.firefox .Sb_QqNKeadm2oq.dq7WRhjf8qPZsx {
  outline-color: AccentColor;
}
.Sb_QqNKeadm2oq.Me5FWzjjmmuQNT {
  opacity: 0.4;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `Sb_QqNKeadm2oq`,
	"collapsed": `WvZExniDZRwinU`,
	"dropTarget": `dq7WRhjf8qPZsx`,
	"isDragging": `Me5FWzjjmmuQNT`
};
export default ___CSS_LOADER_EXPORT___;
